/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getWorksheetsData } from '../../../../actions';
import { NoReports, TileLoader, WorksheetsTable } from '../../../../components';

import { API_URLS, API_PARAMS, API_METHODS } from '../../../../constant';
import { getUserData, invoke } from '../../../../helpers';

const Worksheets = () => {
  const [filteredData, setFilteredData] = useState([]);
  const dispatch = useDispatch();
  const ORG_ID = useSelector((state) => state.session.user.Org.id);
  const { data, loading } = useSelector((state) => state.worksheetsTable);
  const userData = getUserData();

  const getUsersMemberships = (status = API_PARAMS.ACTIVE) => {
    return invoke({ url: API_URLS.ORG + userData.user.Org.id + '/groups', type: API_METHODS.GET, params: { status } });
  };
  const getUsersData = (status = API_PARAMS.ACTIVE) => {
    return invoke({
      url: API_URLS.ORG + userData.user.Org.id + '/report/worksheets',
      type: API_METHODS.GET,
      params: { status },
    });
  };

  useEffect(() => {
    const url = `${API_URLS.ORG}${ORG_ID}${API_URLS.REPORT}${API_URLS.WORKSHEET}`;
    dispatch(getWorksheetsData(url));
    getUsersData().then((result) => {
      getUsersMemberships().then((response) => {
        const map = {};
        let j = 1;
        for (let i = 0; i < response.length; i++) {
          if (response[i].member_access.split(',').includes(userData.user.id) && !map[response[i].name]) {
            map[response[i].name] = j++;
          }
        }
        const filterThis = result.filter((element) => map[element.group]);
        setFilteredData(filterThis);
      });
    });
  }, [ORG_ID]);

  return (
    <>
      {loading && !data.length && <TileLoader />}
      {data.length ? <WorksheetsTable worksheetData={filteredData} /> : <NoReports loading={loading} />}
    </>
  );
};
export default Worksheets;
